export default __webpack_public_path__ + "static/media/ruby.34e792ab.svg";